import { Component, Injector } from '@angular/core';
import { BaseRoute } from '../../../shared/components/base.route';

@Component({
  selector: 'ns-joint-financial-info',
  template: require('./joint-financial-info.component.html')
})

export class JointFinancialInfoComponent extends BaseRoute {
  constructor(injector: Injector) {
    super(injector);

    const steps = this.flowManager.getStepArrays('joint-financial-info');
    this.form.stepsComplete = steps.stepsComplete;
    this.form.stepsToComplete = steps.stepsToComplete;
  }

  ngOnInit() {
    const appType = this.appActions.getData('appType');
    if (appType === 'tka') {
      this.form.inputs.htmlTradingExperience.showUp = false;
      this.form.inputs.isExperienced.showUp = false;
      this.appActions.setData('JointAccountFinancialInformation.isExperienced', false);
    }
  }

  btnClick(e) {
    this.handleClick(e.action);
  }

  updateOptionValue(event) {
    // console.log('Form Route', event);
  }
}
